import { jsxs as _jsxs } from "react/jsx-runtime";
const variantClass = {
    secondary: '',
    primary: 'dhk8-btn--primary',
    ghost: 'dhk8-btn--ghost',
    danger: 'dhk8-btn--danger',
};
const sizeClass = {
    sm: 'dhk8-btn--sm',
    md: '',
    lg: 'dhk8-btn--lg',
};
export function Button({ variant = 'secondary', size = 'md', block, icon, leading, trailing, children, className, type = 'button', ...props }) {
    const classes = [
        'dhk8-btn',
        variantClass[variant],
        sizeClass[size],
        block ? 'dhk8-btn--block' : '',
        icon ? 'dhk8-btn--icon' : '',
        className ?? '',
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("button", { type: type, className: classes, ...props, children: [leading, children, trailing] }));
}
//# sourceMappingURL=Button.js.map